<div>    
  <nav class="col-lg-3 col-md-4 mt-5 p-2 d-none d-lg-block vh-100 overflow-auto bg-dark sidebar-right">

    <!-- <div id="carouselExampleControls" class="carousel slide mt-3" data-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="card">
            <a class="list-group-item text-uppercase font-weight-bolder">PNGL</a>
            <img src="../../../assets/img/cover-ads.png" class="card-img-top" style="height: 12rem;" alt="...">
            <div class="card-body">
              <p class="card-text">PNGL Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <button type="button" class="btn btn-dark btn-block border border-white">Learn More</button>
            </div>
          </div>  
        </div>
        <div class="carousel-item">
          <div class="card">
            <a class="list-group-item text-uppercase font-weight-bolder">PNGL2</a>
            <img src="../../../assets/img/no-cover.png" class="card-img-top" style="height: 12rem;" alt="...">
            <div class="card-body">
              <p class="card-text">PNGL2 Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <button type="button" class="btn btn-dark btn-block border border-white">Learn More</button>
            </div>
          </div>  
        </div>
        <div class="carousel-item">
          <div class="card">
            <a class="list-group-item text-uppercase font-weight-bolder">PNGL3</a>
            <img src="../../../assets/img/cover-ads.png" class="card-img-top" style="height: 12rem;" alt="...">
            <div class="card-body">
              <p class="card-text">PNGL3 Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <button type="button" class="btn btn-dark btn-block border border-white">Learn More</button>
            </div>
          </div>  
        </div>
        <div class="carousel-item">
          <div class="card">
            <a class="list-group-item text-uppercase font-weight-bolder">PNGL4</a>
            <img src="../../../assets/img/no-cover.png" class="card-img-top" style="height: 12rem;" alt="...">
            <div class="card-body">
              <p class="card-text">PNGL4 Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <button type="button" class="btn btn-dark btn-block border border-white">Learn More</button>
            </div>
          </div>  
        </div>
        <div class="carousel-item">
          <div class="card">
            <a class="list-group-item text-uppercase font-weight-bolder">PNGL5</a>
            <img src="../../../assets/img/cover-ads.png" class="card-img-top" style="height: 12rem;" alt="...">
            <div class="card-body">
              <p class="card-text">PNGL5 Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              <button type="button" class="btn btn-dark btn-block border border-white">Learn More</button>
            </div>
          </div>  
        </div>
      </div>
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div> -->

    <div id="carouselExampleControls2" class="carousel slide mt-3" data-ride="carousel">
      <div class="carousel-inner">
        <ng-container *ngFor="let doc of sponsorproductCol | async; index as i; first as isFirst; last as isLast">        
          <div [ngClass]="isFirst ? 'carousel-item active' : 'carousel-item' ">
            <div class="card">
              <div class="media mx-2 mt-3">                        
                <img [src]="doc.ownerProfilePictureUrl" class="mr-3 align-self-center rounded image" alt="...">
                <div class="media-body">
                  <a class="text-uppercase font-weight-bolder stretched-link" routerLink="" (click)="routeToBusinessDetailsPage(doc.ownerDocId)">{{doc.ownerName}}</a>
                <br/>
                <a class="text-uppercase font-weight-bolder text-danger" style="font-size: 10px;">
                  Sponsor Ad
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-all text-danger" viewBox="0 0 16 16">
                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"/>
                  </svg>
                </a>
                </div>
              </div>  
              <img [src]="doc.pictureUrl" class="card-img-top" style="height: 12rem;" alt="...">
              <div class="card-body">
                <p class="card-text font-weight-bold">{{doc.name}}</p>
                <p class="card-text">{{doc.description}}</p>
                <button type="button" class="btn btn-dark btn-block border border-white"
                  (click)="routeToBusinessDetailsPage(doc.businessDocId)"
                  >Learn More</button>
              </div>
            </div>
          </div>  
        </ng-container>       
      </div>
      <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div class="list-group list-group-flush my-3">
      <a class="list-group-item text-uppercase font-weight-bolder">Sponsor</a>
      <a class="list-group-item list-group-item-action" (click)="routeToBusinessDetailsPage(doc.id)"
          [routerLink]="" *ngFor="let doc of sponsorCol | async; let i = index">{{ doc.name }}</a>
      <a class="list-group-item list-group-item-action text-dark bg-warning" [routerLink]="">See All Sponsors</a>
      <a class="list-group-item list-group-item-action text-white bg-danger" [routerLink]="">Sponsor PNGL</a>
    </div>    
    
    <div class="text-white my-2">
      <a class="text-white" [routerLink]="" (click)="routePrivacyPage()">Privacy</a> | <a class="text-white" [routerLink]="" (click)="routeTermsPage()">Terms</a> | <a class="text-white" [routerLink]="" (click)="routeAdvertisePage()">Advertising</a> | PNGL © 2023
    </div>  
  
  </nav>
</div>